import { Medico } from "../../medico/medico";
import { ProcedimentoAgendaPk } from "./pks/procedimento-agenda-pk";
import { ProcedimentoAgendaTomadaPk } from "./pks/procedimento-agenda-tomada-pk";
import { ProcedimentoAgenda } from "./procedimento-agenda";

export class ProcedimentoAgendaTomada {

    pk: ProcedimentoAgendaTomadaPk = new ProcedimentoAgendaTomadaPk();

    agenda: ProcedimentoAgenda = new ProcedimentoAgenda();

    constructor() {
    }
}
